import { initializeApp } from 'firebase/app';
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIRESTORE_apiKey,
  authDomain: import.meta.env.VITE_FIRESTORE_authDomain,
  projectId: import.meta.env.VITE_FIRESTORE_projectId,
  storageBucket: import.meta.env.VITE_FIRESTORE_storageBucket,
  messagingSenderId: import.meta.env.VITE_FIRESTORE_messagingSenderId,
  appId: import.meta.env.VITE_FIRESTORE_appId,
  measurementId: import.meta.env.VITE_FIRESTORE_measurementId,
  databaseURL: import.meta.env.VITE_FIRESTORE_databaseURL
};
const app = initializeApp(firebaseConfig);
export const storage = getStorage(app);
export const firebaseApp = app;
